import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import { AppWrap } from '../../wrapper';
import { client, urlFor } from '../../client';
import './Header.scss';

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
};

const Header = () => {
  const [nameData, setNameData] = useState(null);
  const [brandsData, setBrandsData] = useState([]);

  useEffect(() => {
    const nameQuery = '*[_type == "name"][0]';
    const brandsQuery = '*[_type == "brands"]';

    client.fetch(nameQuery).then((data) => {
      console.log('Name data:', data);
      setNameData(data);
    }).catch(err => console.error('Name fetch error:', err));

    client.fetch(brandsQuery).then((data) => {
      console.log('Brands data:', data);
      setBrandsData(data);
    }).catch(err => console.error('Brands fetch error:', err));
  }, []);

  return (
    <div id="home" className="app__header app__flex">
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__header-info"
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex">
            <span>👋</span>
            <div style={{ marginLeft: 20 }}>
              <p className="p-text">Hello, I am</p>
              <h1 className="head-text">{nameData?.fullName || nameData?.firstName || 'Loading...'}</h1>
            </div>
          </div>

          <div className="tag-cmp app__flex">
            <p className="p-text">{nameData?.title || 'Full Stack Developer'}</p>
            <p className="p-text">{nameData?.nickname || 'React Specialist'}</p>
          </div>
        </div>
      </motion.div>

      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__header-img"
      >
        {nameData?.profileImage && nameData.profileImage.asset ? (
          <img 
            src={urlFor(nameData.profileImage)} 
            alt={nameData.fullName || nameData.firstName} 
            style={{
              width: '100%',
              height: '400px',
              borderRadius: '50%',
              objectFit: 'cover'
            }}
          />
        ) : (
          <div style={{
            width: '100%',
            height: '400px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '2rem',
            fontWeight: 'bold'
          }}>
            {nameData?.firstName?.charAt(0) || 'S'}
          </div>
        )}
      </motion.div>

      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className="app__header-circles"
      >
        {brandsData.map((brand, index) => (
          <div className="circle-cmp app__flex" key={brand._id || index}>
            {brand.imgUrl && brand.imgUrl.asset ? (
              <img 
                src={urlFor(brand.imgUrl)} 
                alt={brand.name} 
                style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} 
              />
            ) : (
              <span style={{ fontSize: '1rem', textAlign: 'center', fontWeight: 'bold' }}>
                {brand.name || 'Brand'}
              </span>
            )}
          </div>
        ))}
        {brandsData.length === 0 && ['📧', '📱', '🔧'].map((icon, index) => (
          <div className="circle-cmp app__flex" key={`circle-${index}`}>
            <span style={{ fontSize: '2rem' }}>{icon}</span>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default AppWrap(Header, 'home');